import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import { EMPLOYEE_MANAGE_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const kpiManagementServiceApi = createApi({
  reducerPath: "kpiManagementServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: EMPLOYEE_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        // if (token) {
        //   headers.set("Authorization", `Bearer ${token}`);
        // }

        // headers.set("ngrok-skip-browser-warning", "true");

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: ["GetKPICycleList", "GetKPICycleDetails", "GetUserAPIAssignedList"],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
